import { useState } from "react";
import { adminAPI } from "../../utility/axios";

// Builds the standard queue payload used by all smoke-test cases.
function buildPayload() {
  return {
    DocusignQueue: {
      MEMAPPID: 1001,
      UPDATEFOR: "INSERT",
      SENDEMAIL: true,
      STATUS: "A",
      USER: "PLAYWRIGHT",
      ISPREVIEWTEMPLATE: false,
    },
  };
}

export default function DocusignQueueSmokeTest() {
  const [status, setStatus] = useState("idle");
  const [queueId, setQueueId] = useState(null);
  const [requestCount, setRequestCount] = useState(0);

  // Sends a single queue request and shows the returned queue ID.
  async function sendQueueRequest() {
    setStatus("sending");
    const response = await adminAPI.post("api/DocusignQueue/UpdateDocusignQueue", buildPayload());
    setQueueId(response.data);
    setRequestCount((c) => c + 1);
    setStatus("sent");
  }

  // Fires two queue requests simultaneously to simulate the duplicate/race-condition scenario.
  async function sendDuplicateQueueRequests() {
    setStatus("sending-duplicate");
    await Promise.all([
      adminAPI.post("api/DocusignQueue/UpdateDocusignQueue", buildPayload()),
      adminAPI.post("api/DocusignQueue/UpdateDocusignQueue", buildPayload()),
    ]);
    setRequestCount((c) => c + 2);
    setStatus("duplicate-sent");
  }

  return (
    <div className="container py-4">
      <h1>DocuSign queue smoke test</h1>
      <p>This page is only enabled when REACT_APP_ENABLE_E2E_TESTS=true.</p>

      <div className="d-flex gap-2">
        <button
          type="button"
          className="btn btn-primary"
          data-testid="send-docusign-queue"
          onClick={sendQueueRequest}
        >
          Send queue request
        </button>
        <button
          type="button"
          className="btn btn-warning"
          data-testid="send-duplicate-queue"
          onClick={sendDuplicateQueueRequests}
        >
          Send duplicate requests
        </button>
      </div>

      <div className="mt-3" data-testid="queue-status">
        Status: {status}
      </div>
      <div data-testid="queue-result">
        Queue ID: {queueId ?? "none"}
      </div>
      <div data-testid="request-count">
        Requests sent: {requestCount}
      </div>
    </div>
  );
}
